'use client';

import { useEffect, useState } from 'react';

import { Button, Typography } from 'lighthouse';

import { Flash } from 'iconsax-react';

interface StickyMobileCtaProps {
    isLoggedIn: boolean;
    onCtaClick: () => void;
    onProductsClick: () => void;
}

const StickyMobileCta = ({ isLoggedIn, onCtaClick, onProductsClick }: StickyMobileCtaProps) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 420);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#050B1E]/90 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3
                backdrop-blur-md transition-transform duration-300 lg:hidden ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
            <div className='flex items-center justify-between gap-3'>
                <Typography variant='caption' component='p' className='flex items-center gap-1.5 font-bold leading-5 text-white'>
                    <Flash size={16} color='#FBBF24' />
                    باتری به باتری رایگان در محل
                    <br />+ 400,000 تومان تخفیف خرید باتری و لوازم یدکی
                </Typography>
                <Button
                    variant='contained'
                    onClick={isLoggedIn ? onProductsClick : onCtaClick}
                    className='shrink-0 bg-amber-400 font-extrabold text-[#0A1530] hover:bg-amber-300'>
                    {isLoggedIn ? 'خرید با تخفیف' : 'دریافت کد'}
                </Button>
            </div>
        </div>
    );
};

export default StickyMobileCta;
